/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionDtoValueType } from './CreateDefinitionDtoValueType';
import {
    CreateDefinitionDtoValueTypeFromJSON,
    CreateDefinitionDtoValueTypeFromJSONTyped,
    CreateDefinitionDtoValueTypeToJSON,
} from './CreateDefinitionDtoValueType';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { NumericValueWithUnitDto } from './NumericValueWithUnitDto';
import {
    NumericValueWithUnitDtoFromJSON,
    NumericValueWithUnitDtoFromJSONTyped,
    NumericValueWithUnitDtoToJSON,
} from './NumericValueWithUnitDto';

/**
 * 
 * @export
 * @interface NumericDataSetFilterDto
 */
export interface NumericDataSetFilterDto {
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetFilterDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetFilterDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetFilterDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetFilterDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NumericDataSetFilterDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NumericDataSetFilterDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {CreateDefinitionDtoValueType}
     * @memberof NumericDataSetFilterDto
     */
    valueType?: CreateDefinitionDtoValueType | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof NumericDataSetFilterDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof NumericDataSetFilterDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<NumericValueWithUnitDto>}
     * @memberof NumericDataSetFilterDto
     */
    selectedValues?: Array<NumericValueWithUnitDto> | null;
    /**
     * 
     * @type {Array<NumericValueWithUnitDto>}
     * @memberof NumericDataSetFilterDto
     */
    availableValues?: Array<NumericValueWithUnitDto> | null;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetFilterDto
     */
    $type?: NumericDataSetFilterDtoTypeEnum;
}


/**
 * @export
 */
export const NumericDataSetFilterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoNumericDataSetFilterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericDataSetFilterDtoTypeEnum = typeof NumericDataSetFilterDtoTypeEnum[keyof typeof NumericDataSetFilterDtoTypeEnum];


/**
 * Check if a given object implements the NumericDataSetFilterDto interface.
 */
export function instanceOfNumericDataSetFilterDto(value?: unknown): value is NumericDataSetFilterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericDataSetFilterDtoTypeEnum)[0];
}

export function NumericDataSetFilterDtoFromJSON(json: any): NumericDataSetFilterDto {
    return NumericDataSetFilterDtoFromJSONTyped(json, false);
}

export function NumericDataSetFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericDataSetFilterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'valueType': !exists(json, 'valueType') ? undefined : CreateDefinitionDtoValueTypeFromJSON(json['valueType']),
        'geometry': !exists(json, 'geometry') ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'selectedValues': !exists(json, 'selectedValues') ? undefined : (json['selectedValues'] === null ? null : (json['selectedValues'] as Array<any>).map(NumericValueWithUnitDtoFromJSON)),
        'availableValues': !exists(json, 'availableValues') ? undefined : (json['availableValues'] === null ? null : (json['availableValues'] as Array<any>).map(NumericValueWithUnitDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericDataSetFilterDtoToJSON(value?: NumericDataSetFilterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'name': value.name,
        'iuid': value.iuid,
        'isEnabled': value.isEnabled,
        'decimalPlaces': value.decimalPlaces,
        'valueType': CreateDefinitionDtoValueTypeToJSON(value.valueType),
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value.geometry),
        'origin': EntityOriginToJSON(value.origin),
        'selectedValues': value.selectedValues === undefined ? undefined : (value.selectedValues === null ? null : (value.selectedValues as Array<any>).map(NumericValueWithUnitDtoToJSON)),
        'availableValues': value.availableValues === undefined ? undefined : (value.availableValues === null ? null : (value.availableValues as Array<any>).map(NumericValueWithUnitDtoToJSON)),
        '$type': value.$type,
    });
}

